export default "__VITE_ASSET__Cxrbx7hs__"